﻿import { FC, useState } from 'react';
import { siteConfig } from '../../config/site';
import { ROUTES } from '../../config/routes';
import { Container } from '../ui/Container';
import { Navigation } from '../ui/Navigation';
import { Button } from '../ui/Button';
import { trackConsultationClick } from '../../analytics/events';

export interface HeaderProps {
  currentPath: string;
  onNavigate: (path: string) => void;
}

export const Header: FC<HeaderProps> = ({ currentPath, onNavigate }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavigate = (path: string) => {
    setMobileMenuOpen(false);
    onNavigate(path);
  };

  const handleConsultationClick = () => {
    setMobileMenuOpen(false);
    trackConsultationClick('header_primary_cta', 'navigation_bar');
    onNavigate(ROUTES.CONTACT);
  };

  return (
    <header
      style={{
        backgroundColor: '#ffffff',
        borderBottom: '1px solid var(--color-border-subtle)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: 'var(--shadow-sm)'
      }}
    >
      <Container size="xl">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '4.75rem'
          }}
        >
          {/* Logo & Brand Identity (Semantic Button for accessibility) */}
          <button
            type="button"
            onClick={() => handleNavigate(ROUTES.HOME)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.85rem',
              textAlign: 'left',
              fontFamily: 'inherit'
            }}
            aria-label="Connect Source Homepage"
          >
                        <img
              src="/connect-source-symbol-square.png"
              alt=""
              aria-hidden="true"
              style={{
                width: '3.25rem',
                height: '3.25rem',
                objectFit: 'contain',
                flexShrink: 0
              }}
            />
            <div>
              <div style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--color-navy-dark)', lineHeight: 1.15 }}>
                {siteConfig.siteName}
              </div>
              <div
                style={{
                  fontSize: '0.7rem',
                  color: 'var(--color-text-muted)',
                  fontWeight: 600,
                  letterSpacing: '0.02em',
                  textTransform: 'uppercase'
                }}
              >
                Career Transformation & HR
              </div>
            </div>
          </button>

          {/* Desktop Navigation */}
          <div className="cs-nav-desktop">
            <Navigation currentPath={currentPath} onNavigate={handleNavigate} />
            <Button
              variant="primary"
              size="sm"
              onClick={handleConsultationClick}
              aria-label="Book a Consultation"
            >
              Book a Consultation
            </Button>
          </div>

          {/* Mobile Menu Toggle Button */}
          <button
            type="button"
            className="cs-mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-nav-menu"
            aria-label={mobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          >
            <span style={{ fontSize: '1.4rem', lineHeight: 1 }}>{mobileMenuOpen ? '✕' : '☰'}</span>
          </button>
        </div>
      </Container>

      {/* Mobile Menu Drawer */}
      <div
        id="mobile-nav-menu"
        className={`cs-mobile-menu ${mobileMenuOpen ? 'is-open' : ''}`}
        aria-hidden={!mobileMenuOpen}
      >
        <Navigation currentPath={currentPath} onNavigate={handleNavigate} isMobile={true} />
        <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid var(--color-border-subtle)' }}>
          <Button
            variant="primary"
            size="md"
            style={{ width: '100%' }}
            onClick={handleConsultationClick}
          >
            Book a Consultation
          </Button>
        </div>
      </div>
    </header>
  );
};


